module.exports = __webpack_public_path__ + "img/www.aliexpress.com.c104350b.png";